import axios from '../utils/axios';

export default function fetchAdditionalInfo(adminId, jobId, applicationId, params) {
    return (
        axios.get('/recruiter/' + adminId + '/jobs/' + jobId + '/candidates/' + applicationId + '/assessment')
    )
}
